import { FC, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/store/hooks';
import CollabCard from 'src/components/StartupScoringEngine/CollabCard/CollabCard';
import {
  hTractionLogoWithText,
  userOnboardingBanner,
  signuplogo,
  loginlogo,
  forgotPasswordlogo,
  Hydangles
} from 'src/assets/images';

import './authLayout.scss';

const AuthLayout: FC = () => {
  // Hooks
  const navigate = useNavigate();
  const location = useLocation()

  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const searchParams = new URLSearchParams(location.search);
  const isSignup = location.pathname === '/sign-up' && ((searchParams.get('partnerInvestor') === 'hyderabad') || (searchParams.get('partnerInvestor') === '6928114050644500111ffebd') || (searchParams.get('partnerInvestor') === '694a86a51eb73f0011898531') || (searchParams.get('partnerInvestor') === '698055b6ffab65001131a971') || (searchParams.get('partnerInvestor') === '698c77905c1b4800115eee5e') || (searchParams.get('partnerInvestor') === '6992b4c63cbfb300118e4fc1') || (searchParams.get('partnerInvestor') === '69b7834db7797a0011d5fc0e') || (searchParams.get('partnerInvestor') === '69b78182b7797a0011d5e59b') || (searchParams.get('partnerInvestor') === '69d39ef9f38d890011aa2fe3'));
  const collabCardProp = searchParams.get('partnerInvestor')
  
  const bannerImage = location.pathname === '/login' ? loginlogo : location.pathname === '/forgot-password' ? forgotPasswordlogo : signuplogo
  console.log(location);

  const redirectIfAuthorized = () => {
    if (isAuthorized) {
      navigate('/dashboard');
    }
  };
  const handleNavigate = () => {
    if (isAuthorized) {
      navigate('/dashboard');
    } else {
      navigate('/');
    }
  }

  useEffect(() => {
    redirectIfAuthorized();
  }, [isAuthorized]);

  return (
    // <div className="auth-layout">
    //   <div className="auth-layout__content">
    //     <div className="auth-layout__content__logo">
    //       <img src={hTractionLogoWithText} alt="htraction logo" onClick={handleNavigate} />
    //     </div>
    //     <div className="auth-layout__content__form">
    //       <Outlet />
    //     </div>
    //   </div>
    //   <img
    //     className="auth-layout__banner"
    //     src={bannerImage}
    //     alt="user onboarding banner"
    //   />
    // </div>
    <div className='loginPage_mainBox'>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="imgBox">
              <img src={hTractionLogoWithText} alt="htraction logo"/>
            </div>
          </div>
                    <div className="col-md-6">
            <div>
              {isSignup ? <CollabCard collabProp={collabCardProp} /> : <img className="auth-layout__banner" src={bannerImage} alt="user onboarding banner"/>}
            </div>
          </div>
          <div className="col-md-6">
            <div className="col-md-10">
              <div style={{ marginTop: '18px' }}>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default AuthLayout;
